// @arch:pure-engine
// Canonical input contract for every New chat entry point. It keeps the UI
// shells from silently diverging on mode, permissions, model or target.

const DEFAULTS = Object.freeze({ kind: 'chat', mode: 'direct', permissions_mode: 'ask' });

export function createClientIntentId() {
  try {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  } catch { /* fall through to the bounded fallback */ }
  return `intent-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

export function buildNewChatIntent(input = {}) {
  const text = String(input.text ?? '').trim();
  const kind = input.kind || DEFAULTS.kind;
  const mode = input.mode || DEFAULTS.mode;
  const permissions_mode = input.permissions_mode || DEFAULTS.permissions_mode;
  const model = input.model || null;
  const client_intent_id = input.client_intent_id || createClientIntentId();
  const target = input.directory || input.github_repo ? {
    directory: input.directory || null,
    github_repo: input.github_repo || null,
  } : null;
  return Object.freeze({
    text,
    kind,
    mode,
    permissions_mode,
    model,
    client_intent_id,
    target,
    attachments: Array.isArray(input.attachments) ? input.attachments.slice() : [],
  });
}

export function intentToSessionInput(intent) {
  if (!intent || typeof intent !== 'object') return {};
  return {
    kind: intent.kind,
    mode: intent.mode,
    permissions_mode: intent.permissions_mode,
    client_intent_id: intent.client_intent_id,
    ...(intent.model ? { model: intent.model } : {}),
    ...(intent.target?.directory ? { directory: intent.target.directory } : {}),
    ...(intent.target?.github_repo ? { github_repo: intent.target.github_repo } : {}),
  };
}
